import FastMarquee from "react-fast-marquee";
import { Sparkle } from "lucide-react";

const items = [
  "Residential Cleaning",
  "STR & Airbnb Turnovers",
  "Commercial Cleaning",
  "Deep Cleaning",
  "Move-In / Move-Out",
  "Reliable · Thorough · Trusted",
];

export default function Marquee() {
  return (
    <div className="bg-foam/15 border-y border-foam/30 py-7 overflow-hidden" data-testid="editorial-marquee">
      <FastMarquee speed={28} gradient={false} pauseOnHover>
        {items.map((item) => (
          <span key={item} className="flex items-center shrink-0">
            <span className="font-editorial italic text-xl md:text-2xl text-seateal px-8">{item}</span>
            <Sparkle size={13} className="text-foamdeep shrink-0" strokeWidth={2} />
          </span>
        ))}
      </FastMarquee>
    </div>
  );
}
